// Blosella funnel — shared behavior
(function(){
  // reveal on scroll
  var els=document.querySelectorAll('.rv');
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}})},{rootMargin:'0px 0px -8% 0px',threshold:.08});
    els.forEach(function(el){io.observe(el)});
  } else els.forEach(function(el){el.classList.add('in')});

  // reading progress (advertorial)
  var bar=document.getElementById('readbar');
  if(bar){
    var art=document.querySelector('[data-article]');
    var onS=function(){
      var r=art.getBoundingClientRect(),h=art.offsetHeight-innerHeight;
      var p=Math.min(1,Math.max(0,-r.top/(h>0?h:1)));
      bar.style.transform='scaleX('+p+')';
    };
    addEventListener('scroll',onS,{passive:true});onS();
  }

  // sticky mobile CTA appears after hero
  var sticky=document.getElementById('stickycta');
  var trig=document.querySelector('[data-sticky-after]');
  if(sticky&&trig&&'IntersectionObserver' in window){
    new IntersectionObserver(function(es){es.forEach(function(e){sticky.classList.toggle('show',!e.isIntersecting&&e.boundingClientRect.top<0)})}).observe(trig);
  }

  // before/after texture slider
  document.querySelectorAll('[data-compare]').forEach(function(c){
    var input=c.querySelector('input'),top=c.querySelector('.cmp-top'),h=c.querySelector('.cmp-handle');
    var set=function(v){top.style.clipPath='inset(0 '+(100-v)+'% 0 0)';h.style.left=v+'%'};
    input.addEventListener('input',function(){set(input.value)});set(input.value);
  });

  // carry UTM / click IDs through the funnel
  try{
    var saved=location.search||'';
    if(saved){document.querySelectorAll('a[data-carry]').forEach(function(a){var u=a.getAttribute('href');if(u.indexOf('?')<0)a.setAttribute('href',u+saved)})}
  }catch(e){}
})();
